import analyticsReducer from '../analyticsReducer';

export default analyticsReducer({
    analyticsActionName: 'ANALYTICS_ORDERS',
});
